import { useEffect, useState } from "react";
import { SIGNUP_URL } from "@/lib/api";
import { Menu, X } from "lucide-react";
import BrandMark from "./BrandMark";

const NAV = [
  { label: "How", href: "#how" },
  { label: "Cards", href: "#cards" },
  { label: "Scanner", href: "#scanner" },
  { label: "ROI", href: "#roi" },
  { label: "Pricing", href: "#pricing" },
  { label: "FAQ", href: "#faq" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-[background,border] duration-300 ${
        scrolled
          ? "bg-[#07182D]/85 backdrop-blur-xl border-b border-white/10"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <a
          href="#top"
          data-testid="logo-link"
          className="flex items-center gap-3 group"
        >
          <BrandMark size={38} />
          <span className="font-display text-xl tracking-tight uppercase hidden sm:inline">
            Street Eats <span className="text-[#D4A017]">Rewards</span>
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {NAV.map((item) => (
            <a
              key={item.href}
              href={item.href}
              data-testid={`nav-${item.label.toLowerCase()}`}
              className="text-sm font-mono uppercase tracking-widest text-white/70 hover:text-[#D4A017] transition-colors"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <a
            href={SIGNUP_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="header-signin"
            className="text-sm font-mono uppercase tracking-widest text-white/70 hover:text-white transition-colors"
          >
            Sign in
          </a>
          <a
            href={SIGNUP_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="header-cta"
            className="btn-brutal bg-[#D4A017] text-[#07182D] font-display uppercase tracking-wide px-5 py-2.5 text-sm border-2 border-[#D4A017] shadow-hard-sm"
          >
            Start Free →
          </a>
        </div>

        <button
          className="md:hidden text-white p-2"
          onClick={() => setOpen((v) => !v)}
          data-testid="mobile-menu-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="md:hidden bg-[#07182D] border-t border-white/10 px-6 py-6 flex flex-col gap-4"
        >
          {NAV.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={() => setOpen(false)}
              className="font-mono uppercase text-sm tracking-widest text-white/80"
            >
              {item.label}
            </a>
          ))}
          <a
            href={SIGNUP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-brutal mt-2 bg-[#D4A017] text-[#07182D] font-display uppercase tracking-wide px-5 py-3 text-center border-2 border-[#D4A017]"
          >
            Start Free Trial
          </a>
        </div>
      )}
    </header>
  );
}
